import { type PropsWithChildren } from "react";
import { useUser } from "@/hooks/useUser";

export function UserProvider({ children }: PropsWithChildren) {
  // This will automatically handle user sync on sign-in
  const { isLoading } = useUser();

  if (isLoading) {
    // You can show a loading state here if needed
    return null;
  }

  return <>{children}</>;
} 